const {
  gql
} = require('@marko/urql');
const QUERY_DYNAMIC_FINDER = gql`
    query brwDynamicFinder(
        $finderPlayerInput: DynamicFinderInput!
        $finderSetInput: DynamicFinderInput!
        $player: Boolean = false
        $set: Boolean = false
        $textSearch: Boolean = false
        $pagination: Boolean = false
    ) {
        player: dynamicFinder(input: $finderPlayerInput) @include(if: $player) {
            ...FinderFragement
        }
        set: dynamicFinder(input: $finderSetInput) @include(if: $set) {
            ...FinderFragement
        }
    }

    fragment FinderFragement on DynamicFinderOutput {
        finder {
            id
            name
            description
            fields {
                id
                name
                selectedValues @include(if: $textSearch) {
                    text: name
                }
                possibleValues @include(if: $pagination) {
                    text: name
                }
            }
        }
    }
`;
const getDynamicFinderInit = queryInput => ({
  player: true,
  set: true,
  textSearch: false,
  pagination: true,
  finderPlayerInput: {
    id: 'us_stc_player',
    filters: [{
      fieldId: 'us_stc_sport',
      selectedCriteria: {
        valueNameSelection: [queryInput]
      }
    }],
    requestedFields: {
      requestedFields: [{
        fieldId: 'us_stc_player',
        paginationInput: {
          possibleValuesPaginationInput: {
            maxPageSize: 200,
            // BE max page size
            pageIndex: 0
          }
        }
      }]
    }
  },
  finderSetInput: {
    id: 'us_stc_set',
    filters: [{
      fieldId: 'us_stc_sport',
      selectedCriteria: {
        valueNameSelection: [queryInput]
      }
    }],
    requestedFields: {
      requestedFields: [{
        fieldId: 'us_stc_year',
        paginationInput: {
          possibleValuesPaginationInput: {
            maxPageSize: 200,
            // BE max page size
            pageIndex: 0
          }
        }
      }]
    }
  }
});
module.exports = {
  QUERY_DYNAMIC_FINDER,
  getDynamicFinderInit
};